export const sugerenciaEmpaqueInitialValues = {
  alias: "",
  cultivo_id: 0,
  tipo_etiqueta_id: 0,
  peso_envase_id: 0,
  tipo_caja_id: 0,
  etiqueta_id: 0,
  palet_id: 0,
  bultos: "",
};
